module.exports = {"apiBaseUrl":null,"flinkLibraryUrl":null}


//////////////////
// WEBPACK FOOTER
// ./src/lib/config/config.base.json
// module id = 8/ZA
// module chunks = 1